import type { DistributorProductVariant } from 'modules/it_management/hooks/device_catalog/types'
import type { MarketplaceProductCardProps } from 'modules/it_management/components/device_catalog/MarketplaceProductCard'

/**
 * Maps a raw DistributorProductVariant from the API to MarketplaceProductCard props.
 */
export function mapVariantToCardProps(
  item: DistributorProductVariant,
  options: {
    imageUrl: string
    isSaved: boolean
    onSaveToggle: () => void
    onClick: () => void
  }
): MarketplaceProductCardProps {
  const productName = item.product?.name || item.sku || item.id
  const title = productName

  const monthlyPrice =
    item.firstOfferPeriod && item.firstOfferPeriod > 0
      ? {
          amount: item.firstOfferCost / item.firstOfferPeriod,
          months: item.firstOfferPeriod,
          currency: 'EUR',
        }
      : undefined

  const badge =
    item.deliveryConditions &&
    item.deliveryConditions.trim() !== '' &&
    item.deliveryConditions !== '-'
      ? { label: item.deliveryConditions }
      : undefined

  return {
    image: options.imageUrl,
    title,
    price: { amount: item.firstOfferCost, currency: 'EUR' },
    monthlyPrice,
    badge,
    isSaved: options.isSaved,
    onSaveToggle: options.onSaveToggle,
    onClick: options.onClick,
    showZeroTouchIcon: false,
  }
}
